module.exports = __webpack_public_path__ + "static/media/texture (28).d8c685e5.jpg";